<template>
  <div class="brand-filter">
    <div class="filter-header">
      <!-- style="color: white;" -->
      <h3 >{{ $t('Brands') }}</h3>
      <div  v-if="selectedBrandNames.length" class="selected-row">
        <!-- style="color: white;" -->
        <span  v-for="name in selectedBrandNames" :key="name">
          {{ name }}
        </span>
        <!-- color="white" -->
        <v-btn  small text @click="clearBrands">
          {{ $t('Clear') }}
        </v-btn>
      </div>
    </div>
    <v-row class="brands-scroll" no-gutters>
      <div :class="{ active: selectedBrandIds.includes(String(item.id)) }"
       v-for="item in sortedBrands" :key="item.id" @click="selectBrand(item.id)" class="toolbar-brand">
        <div >
          <v-img class="toolbar-img-brand" :src="getImgUrl(item.image)" v-if="item.image" />
<!-- :style="!selectedBrandIds.includes(String(item.id)) ? 'color: white;' : ''" -->
          <v-icon  v-else class="toolbar-img-brand">
            mdi-database-outline
          </v-icon>
        </div>
        <h5>{{ item.name }}</h5>
      </div>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'BrandFilter',
  computed: {
    ...mapGetters({
      brands: 'brands/getBrands',
    }),
    selectedBrandIds() {
      return [].concat(this.$route.query.brand_id || []).map(String)
    },
    sortedBrands() {
      return [...this.brands].sort((a, b) => {
        const aSelected = this.selectedBrandIds.includes(String(a.id))
        const bSelected = this.selectedBrandIds.includes(String(b.id))

        if (aSelected === bSelected) return 0
        return aSelected ? -1 : 1
      })
    },
    selectedBrandNames() {
      const selected = [].concat(this.$route.query.brand_id || [])
      return this.brands
        .filter(b => selected.includes(String(b.id)))
        .map(b => b.name)
    },
  },
  methods: {
    ...mapActions({
      fetchBrands: "brands/fetchBrands",
    }),
    selectBrand(id) {
      const current = this.$route.query.brand_id ? [].concat(this.$route.query.brand_id) : [];
      let newBrands
      if (current.includes(String(id))) {
        newBrands = current.filter(b => b !== String(id));
      } else {
        newBrands = [...current, id];
      }
      this.$router.push({
        query: { ...this.$route.query, brand_id: newBrands.length ? newBrands : undefined}
      });
    },
    clearBrands() {
      const query = { ...this.$route.query };
      delete query.brand_id;
      this.$router.push({ query });
    },
    getImgUrl(item) {
      let domain = `${this.$store.state.serverDomain}/storage/`;
      return domain + item;
    },
  },
  created() {
    if(this.brands.length==0)
    this.fetchBrands({paginated: false});
  }
}
</script>

<style scoped>


.toolbar-brand.active {
  background-color: #e8f5e9;
  border: 2px solid #4caf50;
  color: #2e7d32;
}


.brands-scroll {
  display: flex;
  flex-wrap: nowrap;      
  overflow-x: auto;       
  overflow-y: hidden;
  gap: 12px;
  padding: 10px 0;
}



.brands-scroll {
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

}

.brands-scroll::-webkit-scrollbar {
  display: none;
}




.toolbar-brand {
  /* color: white; */
  flex: 0 0 auto;
  height: 80px;
  width: 80px;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s;
}


.toolbar-img-brand {
  height: 60px;
  width: 70px;
  border-radius: 15px;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.5s;
}

.brand-filter {
  /* background: white; */
  padding: 20px;
  /* border-radius: 12px; */
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.1); */
  margin-top: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.filter-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.clear-btn {
  background: none;
  border: 1px solid #ddd;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
}

.clear-btn:hover {
  background: #f8f9fa;
  border-color: #999;
}

.brands {
  overflow-x: scroll;
  
}

.brand-btn {
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  transition: all 0.3s ease;
}

.brand-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.brand-btn.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}
</style>